import React, { useState } from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { Col, Row, Button, Card, CardText, CardTitle, Spinner } from 'reactstrap'
import { handleBackToCompanies, handleSyncNow, handleDeleteCompany } from '../actions/companyActions'
import HeaderRow from '../Shared/LayoutComponents/HeaderRow'
import DeleteModal from '../Shared/DeleteModal'
import LastSyncDetails from './LastSyncDetails'
import PageHeading from '../Shared/LayoutComponents/PageHeading'
import { AzureAD, AuthenticationState } from 'react-aad-msal'
import { authProvider } from '../../services/authProvider'

let DashCard = styled(Card)`
  text-align: center;
  padding: 10px;
`

let DashCardText = styled(CardText)`
  font-size: 36px;
  font-weight: 500;
  color: #0b478c;
`

let DateCardText = styled(CardText)`
  font-size: 28px;
  font-weight: 500;
  color: #0b478c;
`

let DashCardTitle = styled(CardTitle)`
  font-weight: 500;
`

let TopContainer = styled.div`
  padding-bottom: 10px;
`

const CompanyDetailsTable = (props) => {
  const [modal, setModal] = useState(false)
  const toggleModal = () => setModal(!modal)

  return (
    <AzureAD provider={authProvider}>
      {({ login, logout, authenticationState, accountInfo }) => {
        let isAdmin = false
        if (accountInfo && accountInfo.account && accountInfo.account.idToken && accountInfo.account.idToken.roles) {
          if (accountInfo.account.idToken.roles.includes('Admin')) {
            isAdmin = true
          }
        }

        return (
          <TopContainer>
            <Row>
              <Col md={8}>
                <PageHeading>{(props.selectedCompany && props.selectedCompany.companyName) ?? "Loading"}</PageHeading>
              </Col>
              <Col md={4}>
                <div style={{ display: "flex", "justify-content": "end", gap: "12px" }}>
                  <Button
                    disabled={props.syncLoading}
                    outline
                    color="primary"
                    onClick={() => props.handleSyncNow(props.selectedCompany && props.selectedCompany.id)}
                  >
                    {props.syncLoading ? (
                      <span>
                        <Spinner style={{ height: '1.15rem', width: '1.15rem' }} color="primary" /> Syncing
                      </span>
                    ) : (
                      'Sync Now'
                    )}
                  </Button>{' '}
                  {isAdmin && (
                    <Button outline color="danger" onClick={toggleModal}>
                      Delete
                    </Button>
                  )}
                  <Button
                    outline
                    onClick={props.handleBackToCompanies}
                    color='secondary'
                  >
                    Back
                  </Button>
                </div>
              </Col>
            </Row>
            <HeaderRow small={true}>
              <Col md={4} sm={4}>
                <DashCard>
                  <DashCardTitle>Billed Users</DashCardTitle>
                  <DashCardText>{(props.selectedCompany && props.selectedCompany.billedUserCount) ?? "Loading"}</DashCardText>
                </DashCard>
              </Col>
              <Col md={4} sm={4}>
                <DashCard>
                  <DashCardTitle>Total Users</DashCardTitle>
                  <DashCardText>{(props.selectedCompany && props.selectedCompany.userCount) ?? "Loading"}</DashCardText>
                </DashCard>
              </Col>
              <Col md={4} sm={6}>
                <DashCard style={{ minHeight: '100%' }}>
                  <DashCardTitle>Last Sync</DashCardTitle>
                  <DateCardText>
                    <LastSyncDetails selectedCompany={props.selectedCompany} />
                  </DateCardText>
                </DashCard>
              </Col>
            </HeaderRow>
            {isAdmin && (
              <DeleteModal
                modal={modal}
                toggleModal={toggleModal}
                handleDeleteCompany={props.handleDeleteCompany}
                name={props.selectedCompany && props.selectedCompany.companyName}
                id={props.selectedCompany && props.selectedCompany.id}
              />
            )}
          </TopContainer>
        )
      }}
    </AzureAD>
  )
}

const mapStateToProps = (state) => ({
  selectedCompany: state.company.selectedCompany,
  syncLoading: state.company.syncLoading,
})

const mapDispatchToProps = {
  handleBackToCompanies,
  handleSyncNow,
  handleDeleteCompany,
}

export default connect(mapStateToProps, mapDispatchToProps)(CompanyDetailsTable)
